export function findTargetMessageIndex(toolType?: string): number {
  const state = (window as any).reduxStore?.getState()
  const messages = state?.chatDrawer?.messages || []

  // Find the last receive message with toolExecutionState
  // If toolType is provided, only match that specific tool type
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].direction === 'receive' && messages[i].toolExecutionState) {
      if (!toolType || messages[i].toolExecutionState.toolType === toolType) {
        return i
      }
    }
  }

  return -1
}

export function getLastMessageIndex(): number {
  const state = (window as any).reduxStore?.getState()
  const messages = state?.chatDrawer?.messages || []
  return messages.length > 0 ? messages.length - 1 : -1
}
